/* eslint-disable */


var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

const getJSON = require('../coordinates_fontaine.json');


if (document.querySelector('#map-fontaine')) {

  mapboxgl.accessToken =
    'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2ttNmYyeGZ3MGJrcjJ6bXoxYXQ1eHczNSJ9.i7HdmSaktCWLdzFqBBXI8Q'
  let mapEau = new mapboxgl.Map({
    container: 'map-fontaine',
    center: [6.166667, 49.133333],
    zoom: 11,
    maxZoom: 15,
    minZoom: 8,
    style: 'mapbox://styles/mapbox/streets-v11',
  })



  const data = [];
  getJSON.forEach(obj => {
    data.push({
      name: obj.name,
      address: obj.address,
      coordinates: obj.coordinates.split(','),
    })
  })

  console.log(data)


  data.forEach(obj => {
    // const marker = document.createElement('div');
    // marker.className = "marker";
    // marker.setAttribute('data-color', obj.color_name)

    const popup = new mapboxgl.Popup({ offset: 25 })
    popup.setHTML('<div class="popup_name">' +
      obj.name +
      '</div><p class="popup_address">' +
      obj.address +
      '</p>');


    // new mapboxgl.Marker({ element: marker })
    new mapboxgl.Marker()
      .setLngLat(obj.coordinates.reverse())
      .setPopup(popup) // add popups
      .addTo(mapEau);



  });

}






// WEBPACK FOOTER //
// ./scripts/map-fontaine.js